/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pricing_Compare_Team_PresetsInputs */



/**
* | output |
* | --- |
* | "Viewer, manager and admin presets" |
*
* @param {Pricing_Compare_Team_PresetsInputs} inputs
* @param {{ locale?: "en" | "ru" }} options
* @returns {LocalizedString}
*/
export const pricing_compare_team_presets = /** @type {((inputs?: Pricing_Compare_Team_PresetsInputs, options?: { locale?: "en" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pricing_Compare_Team_PresetsInputs, { locale?: "en" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ru") return /** @type {LocalizedString} */ ("Пресеты наблюдателя, менеджера и администратора")
	return /** @type {LocalizedString} */ ("Viewer, manager and admin presets")
});